/*
  Stops the page jumping when a Hat is picked.

  The Hat Picker is a CSS-only radio group: all six inputs are the first
  children of `.hat-picker__interactive`, absolutely positioned and clipped to
  1px, and the `:checked ~ .hat-picker__panels` selectors are what swap the
  panel. That means the input a swatch belongs to sits at the TOP of the
  section while the swatch itself is much further down.

  Clicking the swatch focuses that input, and when the input is above the
  viewport the browser scrolls up to reveal it — so choosing a Hat threw the
  reader back up the page.

  `focus({ preventScroll: true })` is the fix: check the input and move focus
  without the browser scrolling to it. Selection, the panel swap and the bird's
  reaction all still run off the same `change` event, so nothing downstream
  changes.

  Without this file the swatches still work natively — they just scroll.
*/
(function () {
  'use strict';

  var SWATCH = '.hat-picker__swatch';

  function onClick(event) {
    var swatch = event.target.closest ? event.target.closest(SWATCH) : null;
    if (!swatch) return;

    var input = document.getElementById(swatch.getAttribute('for'));
    if (!input || input.disabled) return;

    // The label's own default would both check the input and scroll to it, so
    // it has to be replaced rather than corrected after the fact.
    event.preventDefault();

    var alreadyChecked = input.checked;
    input.checked = true;

    try {
      input.focus({ preventScroll: true });
    } catch (error) {
      /* Older browsers ignore the options object; selection still worked. */
    }

    // Re-picking the current Hat is not a change, and firing anyway would make
    // the bird replay its reaction for a no-op.
    if (!alreadyChecked) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', onClick);

  /*
    One gentle bounce across the hats the first time a highlighted Hat Picker
    comes into view, so a visitor notices they are buttons. Runs once per page
    load and never repeats; the CSS drops the animation entirely under
    prefers-reduced-motion. Without IntersectionObserver nothing happens and
    the hats simply don't bounce.
  */
  var INVITE_CLASS = 'is-inviting';
  var INVITE_MS = 2200;

  function watchForInvite(picker) {
    if (picker.dataset.hatInviteWatched) return;
    picker.dataset.hatInviteWatched = 'true';
    var observer = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        picker.classList.add(INVITE_CLASS);
        window.setTimeout(function () {
          picker.classList.remove(INVITE_CLASS);
        }, INVITE_MS);
      },
      { threshold: 0.35 }
    );
    observer.observe(picker.querySelector('.hat-picker__swatches') || picker);
  }

  function initInvites() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('.hat-picker--highlight').forEach(watchForInvite);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInvites);
  } else {
    initInvites();
  }
  // Theme Editor re-renders the section; watch the new copy too.
  document.addEventListener('shopify:section:load', initInvites);
})();
